// TODO(MOB-17099): Convert these to .gql files once deployed to the production GraphQL schema.
// Using .ts template strings to bypass the gql gatekeeper CI job (`test_backend_frontend_contract`)
// which validates against the live prod schema. Track BE PR: https://github.com/GetEvinced/prod-mon/pull/3319
export const MFA_SCANS_LIST_QUERY = `
	query MfaScansList(
		$runId: ConditionID!
		$totalIssuesMinFilter: ConditionInt
		$scanNameFilter: ConditionString
		$offset: Int
		$limit: Int
		$sort: mfa_scans_listSort
	) {
		mfa_scans_list(
			run_id_eq: $runId
			total_issues_gt: $totalIssuesMinFilter
			scan_name_eq: $scanNameFilter
			offset: $offset
			limit: $limit
			sort: $sort
		) {
			tenant_id
			run_id
			scan_id
			scan_name
			scan_created_at
			scan_screenshot_url
			total_issues
			critical_issues
			serious_issues
			elements_with_issues
		}

		total: mfa_scans_list(
			run_id_eq: $runId
			total_issues_gt: $totalIssuesMinFilter
			scan_name_eq: $scanNameFilter
		) {
			scan_id_count
			total_issues_sum
			elements_with_issues_sum
		}
	}
`;

export const MSDK_SCANS_LIST_QUERY = `
	query MsdkScansList(
		$runId: ConditionID!
		$totalIssuesMinFilter: ConditionInt
		$scanNameFilter: ConditionString
		$offset: Int
		$limit: Int
		$sort: msdk_scans_listSort
	) {
		msdk_scans_list(
			run_id_eq: $runId
			total_issues_gt: $totalIssuesMinFilter
			scan_name_eq: $scanNameFilter
			offset: $offset
			limit: $limit
			sort: $sort
		) {
			tenant_id
			run_id
			scan_id
			scan_name
			scan_created_at
			scan_screenshot_url
			total_issues
			critical_issues
			serious_issues
			elements_with_issues
		}

		total: msdk_scans_list(
			run_id_eq: $runId
			total_issues_gt: $totalIssuesMinFilter
			scan_name_eq: $scanNameFilter
		) {
			scan_id_count
			total_issues_sum
			elements_with_issues_sum
		}
	}
`;
